import type { Lang } from '@/data/categories';
import { homeContent } from '@/data/home';
import { MAIN_SITE_URL } from '@/data/categories';

interface Props {
  lang: Lang;
  search: string;
  onSearch: (v: string) => void;
}

export default function Hero({ lang, search, onSearch }: Props) {
  const c = homeContent[lang];

  return (
    <section className="relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20flat%20lay%20composition%20with%20floating%20fashion%20product%20silhouettes%20of%20sneakers%20hoodie%20and%20handbag%20on%20a%20soft%20sage%20green%20and%20warm%20cream%20gradient%20background%2C%20minimal%20editorial%20style%2C%20clean%20airy%20negative%20space%2C%20high%20detail%2C%20harmonious%20modern%20aesthetic&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="AllChinaBuy Spreadsheet resources"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/30"></div>

      <div className="relative mx-auto flex max-w-7xl flex-col items-center px-4 md:px-6 py-24 md:py-32 text-center">
        <span className="mb-5 rounded-full bg-background-50/20 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur">
          {c.announcement}
        </span>

        <h1 className="max-w-4xl text-3xl font-extrabold leading-tight text-background-50 md:text-5xl">
          {c.hero.h1}
        </h1>

        <p className="mt-5 max-w-2xl text-base text-background-100/90 md:text-lg">
          {c.hero.subtitle}
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition hover:bg-primary-600 md:text-base"
          >
            {c.hero.cta1}
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
          <a
            href="#guides"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('guides')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition hover:bg-background-50/20 md:text-base"
          >
            {c.hero.cta2}
            <i className="ri-arrow-down-line text-lg"></i>
          </a>
        </div>

        <div className="mt-8 w-full max-w-xl">
          <div className="flex items-center gap-2 rounded-full bg-background-50 px-4 py-3">
            <i className="ri-search-line text-lg text-foreground-400"></i>
            <input
              type="text"
              value={search}
              onChange={(e) => onSearch(e.target.value)}
              placeholder={c.hero.search}
              className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
            />
          </div>
        </div>

        <p className="mt-6 text-xs text-background-100/80">{c.hero.trust}</p>
      </div>
    </section>
  );
}